import React, { ReactElement } from 'react'
import { DO_NOT_TRACK_ATTRIBUTE_PROPS } from './constants'

/**
 * Compound component to wrap an input with personally identifiable information (PII).
 * Value of the input will not be sent to GA4 on input interaction.
 **/
export const DoNotTrack = ({ children }: { children: React.ReactNode }): ReactElement => {
    return (
        <div className="contents" {...DO_NOT_TRACK_ATTRIBUTE_PROPS}>
            {children}
        </div>
    )
}
